import axios from "axios";

export const sendFormJsonFromApi = (data) =>
  axios.post('https://privacy.maggiolicloud.it/api/v1/post/send', data)
    .then(response => response.data)
    .catch(error => error);
